export const AdminLeadAutomationPermissions = {
  AdminLeadAutomationPermissions: {
    permissionsId: "c0c19d0f-51cb-4102-f94b-08dc0f48c1d2",
    permissionsName: "Lead Automation Dashboard",
    description: null,
    componentsId: null,
    components: null
  },
};
